export default "__VITE_ASSET__BaEjZtql__"